import React from 'react';
import { VerticalForm, FormInput } from '../../components/';
import { Modal, Button, Spinner } from 'react-bootstrap';
import moment from 'moment';

const EditMasterModal = ({
    t,
    title,
    showModal,
    closeModalWithHeaderClass,
    onSubmit,
    schemaResolver,
    extraField,
    showEditModalData = {},
    stationName = [],
    vendor = [],
    loader,
    varient,
}) => {
    return (
        <Modal show={showModal} size="lg" onHide={closeModalWithHeaderClass}>
            <Modal.Header closeButton className="modal-colored-header">
                <h4 className="modal-title text-black">{t(title)}</h4>
            </Modal.Header>

            <Modal.Body>
                <style>{`
                    .edit-master-two-col form {
                        display: grid;
                        grid-template-columns: repeat(2, 1fr);
                        column-gap: 1.5rem;
                    }
                    .edit-master-two-col form .full-width-row {
                        grid-column: 1 / -1;
                    }
                `}</style>

                <div className="edit-master-two-col">
                    <VerticalForm onSubmit={onSubmit} resolver={schemaResolver}>
                        {/* Extra Field from Parent */}
                        {extraField && (
                            <FormInput
                                label={t(extraField.label)}
                                type={extraField.type}
                                name={extraField.name}
                                placeholder={t(extraField.placeholder)}
                                defaultValue={extraField.value}
                                containerClass="mb-3"
                                onInput={extraField.onInput}
                            />
                        )}

                        <FormInput
                            label={t('Asset Type Code')}
                            type="text"
                            name="assetTypeCode"
                            placeholder={t('Enter asset type code')}
                            defaultValue={showEditModalData.asset_type_code || ''}
                            containerClass="mb-3"
                        />

                        <FormInput
                            label={t('Asset Type ID')}
                            type="text"
                            name="assetTypeId"
                            placeholder={t('Enter asset type id')}
                            defaultValue={showEditModalData.asset_type_id || ''}
                            containerClass="mb-3"
                        />

                        <FormInput
                            label={t('SMMS Asset Code')}
                            type="text"
                            name="smmsAssetCode"
                            placeholder={t('Enter smms asset code')}
                            defaultValue={showEditModalData.smms_asset_code || ''}
                            containerClass="mb-3"
                        />

                        <FormInput
                            label={t('SMMS Asset Name')}
                            type="text"
                            name="smmsAssetName"
                            placeholder={t('Enter smms asset name')}
                            defaultValue={showEditModalData.smms_asset_name || ''}
                            containerClass="mb-3"
                        />

                        <FormInput
                            label={t('Asset Number Code')}
                            type="text"
                            name="assetNumberCode"
                            placeholder={t('Enter asset number code')}
                            defaultValue={showEditModalData.asset_number_code || ''}
                            containerClass="mb-3"
                        />

                        <FormInput
                            label={t('Asset Number ID')}
                            type="text"
                            name="assetNumberId"
                            placeholder={t('Enter asset number id')}
                            defaultValue={showEditModalData.asset_number_id || ''}
                            containerClass="mb-3"
                        />

                        <FormInput
                            label={t('Parameter Type ID')}
                            type="text"
                            name="parameterTypeId"
                            placeholder={t('Enter parameter type id')}
                            defaultValue={showEditModalData.parameter_type_id || ''}
                            containerClass="mb-3"
                        />

                        <FormInput
                            label={t('Device ID')}
                            type="text"
                            name="deviceId"
                            placeholder={t('Enter device id')}
                            defaultValue={showEditModalData.device_id || ''}
                            containerClass="mb-3"
                            // disabled
                        />

                        <FormInput
                            label={t('Internal ID')}
                            type="text"
                            name="internalId"
                            placeholder={t('Enter internal id')}
                            defaultValue={showEditModalData.internal_id || ''}
                            containerClass="mb-3"
                        />

                        <FormInput
                            label={t('Channel Number')}
                            type="text"
                            name="channel"
                            placeholder={t('Enter channel number')}
                            defaultValue={showEditModalData.channel || ''}
                            containerClass="mb-3"
                            onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ''))}
                        />

                        {/* Type Select */}
                        <FormInput type="select" label={t('Type')} name="type" key="typeSelect" containerClass="mb-3">
                            <option value={showEditModalData.type || ''}>
                                {showEditModalData.type
                                    ? showEditModalData.type.charAt(0).toUpperCase() + showEditModalData.type.slice(1)
                                    : t('Select Type')}
                            </option>
                            {['current', 'voltage'].map((item) =>
                                item !== showEditModalData.type?.toLowerCase() ? (
                                    <option key={item} value={item}>
                                        {item.charAt(0).toUpperCase() + item.slice(1)}
                                    </option>
                                ) : null
                            )}
                        </FormInput>

                        {/* Vendor Select */}
                        <FormInput type="select" label={t('Vendor Name')} name="vendorId" containerClass="mb-3">
                            <option value={showEditModalData.vendor_id || ''}>
                                {showEditModalData?.vendorDetails?.vendor_cloud_name || t('Select Vendor')}
                            </option>
                            {vendor
                                .filter((item) => item.id !== showEditModalData.vendor_id)
                                .map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.vendor_cloud_name}
                                    </option>
                                ))}
                        </FormInput>

                        {/* Station Select */}
                        <FormInput type="select" label={t('Station Name')} name="stationId" containerClass="mb-3">
                            <option value={showEditModalData.station_id || ''}>
                                {showEditModalData?.stationDetails?.name || t('Select Station')}
                            </option>
                            {stationName
                                .filter((item) => item.id !== showEditModalData.station_id)
                                .map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                        </FormInput>

                        {/* Created Date */}
                        <FormInput
                            label={t('Created Date')}
                            type="text"
                            defaultValue={moment(showEditModalData?.updatedAt).format('Do MMM YYYY, h:mm A') || ''}
                            containerClass="mb-3"
                            disabled
                        />

                        {/* Footer - spans both columns */}
                        <Modal.Footer className="full-width-row d-flex justify-content-end">
                            <Button
                                type="submit"
                                className="btn btn-submit"
                                style={{
                                    backgroundColor: '#F9B74C',
                                    fontFamily: 'Poppins, sans-serif',
                                    width: '200px',
                                    borderRadius: '0%',
                                    border: 'none',
                                }}
                                disabled={loader}>
                                {loader ? (
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="grow"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                        {t(' Loading')}
                                    </>
                                ) : (
                                    <>
                                        <i className="mdi mdi-login"></i>
                                        {t('Submit')}
                                    </>
                                )}
                            </Button>
                        </Modal.Footer>
                    </VerticalForm>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default EditMasterModal;
